import React from "react";
import Svg, { Path } from "react-native-svg";

const ArrowDownIcon = ({ width, height, color }) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 15 9"
      preserveAspectRatio="xMidYMin meet"
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.905492 0.715795C1.00036 0.620691 1.11305 0.545237 1.23712 0.493754C1.36119 0.442271 1.49419 0.415771 1.62852 0.415771C1.76285 0.415771 1.89585 0.442271 2.01992 0.493754C2.14399 0.545237 2.25669 0.620691 2.35155 0.715795L7.75588 6.12217L13.1602 0.715795C13.352 0.524036 13.6121 0.416306 13.8832 0.416306C14.1544 0.416306 14.4145 0.524036 14.6063 0.715795C14.798 0.907554 14.9058 1.16764 14.9058 1.43882C14.9058 1.71001 14.798 1.97009 14.6063 2.16185L8.47891 8.28921C8.38405 8.38432 8.27135 8.45977 8.14728 8.51125C8.02322 8.56274 7.89021 8.58924 7.75588 8.58924C7.62156 8.58924 7.48855 8.56274 7.36448 8.51125C7.24041 8.45977 7.12772 8.38432 7.03285 8.28921L0.905492 2.16185C0.810389 2.06699 0.734934 1.95429 0.683451 1.83023C0.631968 1.70616 0.605469 1.57315 0.605469 1.43882C0.605469 1.3045 0.631968 1.17149 0.683451 1.04742C0.734934 0.923351 0.810389 0.810658 0.905492 0.715795Z"
        fill={color}
      />
    </Svg>
  );
};

ArrowDownIcon.defaultProps = {
  width: 15,
  height: 9,
  color: "#A8A9B7",
};

export default ArrowDownIcon;
